import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GoalsLightQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.GoalsFilters>;
}>;


export type GoalsLightQuery = { goals: { edges?: Array<{ node: { id: string, name: string, description?: string | null } }> | null } };


export const GoalsLightDocument = /*#__PURE__*/ gql`
    query goalsLight($filters: GoalsFilters) {
  goals(filters: $filters) {
    edges {
      node {
        id
        name
        description
      }
    }
  }
}
    `;

export function useGoalsLightQuery(options?: Omit<Urql.UseQueryArgs<GoalsLightQueryVariables>, 'query'>) {
  return Urql.useQuery<GoalsLightQuery, GoalsLightQueryVariables>({ query: GoalsLightDocument, ...options });
};